// extracted by mini-css-extract-plugin
export default {"box":"ccfyaIGlfYqRF7ZPJr_x","entityLogo":"CvVqF8XOTp7V78oLgbeL","separatorLine":"do_YP4RfoT393HQ9SaUa","logo":"TtowPXrZzyHQt3SkdLvC"};